import type {SVGProps} from 'react'

const SvgExternalLinkLarge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns={'http://www.w3.org/2000/svg'}
    width={48}
    height={48}
    fill={'none'}
    viewBox={'0 0 48 48'}
    {...props}
  >
    <path
      fill={'currentColor'}
      fillRule={'evenodd'}
      d={'M32.116 15.886v14.767h-1.25V17.136H17.349v-1.25z'}
      clipRule={'evenodd'}
    />
    <path
      fill={'currentColor'}
      fillRule={'evenodd'}
      d={'M16.078 31.04 31.05 16.07l.884.883-14.97 14.97z'}
      clipRule={'evenodd'}
    />
  </svg>
)
export default SvgExternalLinkLarge
